(() => {
  // Elements that should still allow copy (inputs, editable areas, or anything you mark up)
  const ALLOW_SELECTOR = 'input, textarea, [contenteditable="true"], [data-allow-copy]';
  const canBlock = (el) => !el.closest(ALLOW_SELECTOR);

  const stop = (e) => {
    if (canBlock(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  };

  // 1) Right-click / long-press menu
  document.addEventListener('contextmenu', stop, true);

  // 2) Select / drag (keeps forms usable because of ALLOW_SELECTOR)
  document.addEventListener('selectstart', stop, true);
  document.addEventListener('dragstart', stop, true);

  // 3) Copy / cut
  document.addEventListener('copy', stop, true);
  document.addEventListener('cut', stop, true);

  // 4) Common “copy/view” keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    // Allow typing & shortcuts inside allowed elements
    if (!canBlock(e.target)) return;

    const key = e.key.toLowerCase();
    const isMac = /mac/i.test(navigator.platform);
    const mod = isMac ? e.metaKey : e.ctrlKey;

    // Ctrl/Cmd + (C, X, S, P, U, A)
    if (mod && ['c', 'x', 's', 'p', 'u', 'a'].includes(key)) return stop(e);

    // DevTools-ish combos and F12
    if ((mod && e.shiftKey && ['i', 'c', 'j'].includes(key)) || key === 'f12') return stop(e);
  }, true);

  // 5) Optional: make all images non-draggable at runtime
  addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('img').forEach((img) => img.setAttribute('draggable', 'false'));
  });

  // (Separate from “iframe protection” topic—omitted here)
})();